import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGlass: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="glass, material, shader, liquid-glass"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12.5 6.02054C12.3351 6.00694 12.1684 6 12 6C8.68629 6 6 8.68629 6 12C6 12.1684 6.00694 12.3351 6.02054 12.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconGlass;
